import { Col, Row } from "reactstrap";
import CommonBreadcrumb from "../../CommonElements/CommonBreadcrumb/CommonBreadcrumb";
import { useAppSelector } from "../../ReduxToolkit/Hooks";
import HeaderLogo from "./HeaderLogo";
import SidebarButton from "./HeaderLogoWrapper/HeaderLogoWrapper";
import RightHeader from "./RightHeader/RightHeader";

const Header = () => {
  const { toggleSidebar, scroll } = useAppSelector((state) => state.layout);
  return (
    <Row
      className={`page-header ${toggleSidebar ? "close_icon" : ""}`}
      id="pageheaders"
      style={{ display: scroll ? "none" : "" }}
    >
      <HeaderLogo />
      <CommonBreadcrumb />
      <Col className="header-wrapper m-0">
        <Row>
          <SidebarButton />
          <RightHeader />
        </Row>
      </Col>
    </Row>
  );
};

export default Header;
